import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import AdjustDuration
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/Common/AdjustDuration/AdjustDuration'
import AdjustDurationIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/Common/AdjustDuration/AdjustDuration'
import { resetCounter } from '@app/actions/scenes/counter'
import {
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  restoreActionInfo,
} from '@app/actions/scenes/currentSceneCreating'
import {
  SELECT_VIRTUAL_SWITCH_ACTION_STATE,
  SELECT_VIRTUAL_SWITCH_VALUE_AFTER_DURATION,
} from '@app/constants/routes'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(AdjustDurationIOS) : withStyles(AdjustDuration)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { counter: counterInfo } = state.scenes
  const { durationValueAfter, stateDescription } = state.scenes.currentSceneCreating.currentAction
  const pathForButtons = SELECT_VIRTUAL_SWITCH_ACTION_STATE
  const pathForValueAfterDuration = SELECT_VIRTUAL_SWITCH_VALUE_AFTER_DURATION
  return {
    isMobile,
    path,
    pathForButtons,
    counterInfo,
    durationValueAfter,
    stateDescription,
    pathForValueAfterDuration,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  restoreActionInfo,
  resetCounter,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const AdjustDurationEnhanced = enhance

export default withRouter(AdjustDurationEnhanced)
